import React, { useEffect, useState } from "react";

import { Box, Button, TextField, Typography } from "@mui/material";

import {
  clearSlateId,
  getSlateId,
  setSlateId,
} from "../../../helpers/slate-id";
import GenericDialog from "../../shared/generic-dialog";

interface DevToolsDialogProps {
  open: boolean;
  onClose: () => void;
}

const DevToolsDialog = ({ open, onClose }: DevToolsDialogProps) => {
  const [slateId, setSlateIdInput] = useState<string>("");

  useEffect(() => {
    if (open) {
      setSlateIdInput(getSlateId() ?? "");
    }
  }, [open]);

  const handleSave = () => {
    const trimmed = slateId.trim();
    if (trimmed) {
      setSlateId(trimmed);
    } else {
      clearSlateId();
    }
    onClose();
  };

  const handleClear = () => {
    clearSlateId();
    setSlateIdInput("");
    onClose();
  };

  return (
    <GenericDialog
      title="Dev Tools"
      open={open}
      handleDialogClose={onClose}
      hasXCloseBtn={true}
      hasAckBtn={true}
      acknowledgeBtnLabel="Save"
      handleAckBtnClick={handleSave}
    >
      <Box sx={{ width: "100%", mt: 2 }}>
        <TextField
          label="Slate ID"
          placeholder="e.g. FG-1234"
          value={slateId}
          onChange={(e) => setSlateIdInput(e.target.value)}
          fullWidth
        />
        <Typography
          variant="caption"
          color="text.secondary"
          sx={{ mt: 1, display: "block" }}
        >
          Sets the SC-SLATE-ID header on all API requests. Only active in dev
          environment.
        </Typography>
        <Button
          variant="text"
          size="small"
          onClick={handleClear}
          sx={{ mt: 0.5, p: 0, minWidth: 0 }}
        >
          Clear Slate ID
        </Button>
      </Box>
    </GenericDialog>
  );
};

export default DevToolsDialog;
